/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductReviewList
// ====================================================

export interface GetProductReviewList_ux_review_list_item_list_fulfillment_badge_image_size {
  /**
   * 이미지 너비 크기
   */
  width: number;
  /**
   * 이미지 높이 크기
   */
  height: number;
}

export interface GetProductReviewList_ux_review_list_item_list_fulfillment_badge {
  type: string | null;
  text: string | null;
  image_url: string;
  image_size: GetProductReviewList_ux_review_list_item_list_fulfillment_badge_image_size | null;
}

export interface GetProductReviewList_ux_review_list_item_list_like_list {
  type: string;
  count: number;
}

export interface GetProductReviewList_ux_review_list_item_list_reply_list {
  /**
   * 상품리뷰 답글 내용
   */
  contents: string;
}

export interface GetProductReviewList_ux_review_list_item_list_requested_user {
  is_mine: boolean;
  liked_list: string[];
  is_abuse_reported: boolean;
}

export interface GetProductReviewList_ux_review_list_item_list_attachment_list {
  /**
   * 원본 파일 URL
   */
  original_url: string;
  /**
   * 썸네일 파일 URL
   */
  thumbnail_url: string;
  /**
   * 상품리뷰 첨부파일 상태 (NORMAL, EXCLUDED_BY_USER, DELETED_BY_ADMIN)
   */
  status: string;
}

export interface GetProductReviewList_ux_review_list_item_list_attribute_list_question {
  label: string;
  value: string;
  category: string;
}

export interface GetProductReviewList_ux_review_list_item_list_attribute_list_answer {
  label: string;
  value: string;
}

export interface GetProductReviewList_ux_review_list_item_list_attribute_list {
  /**
   * 질문
   */
  question: GetProductReviewList_ux_review_list_item_list_attribute_list_question;
  /**
   * 답변
   */
  answer: GetProductReviewList_ux_review_list_item_list_attribute_list_answer;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_icon_url {
  normal: string;
  dark: string | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text_color {
  normal: string | null;
  dark: string | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text_html {
  normal: string | null;
  dark: string | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text {
  text: string;
  color: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text_color | null;
  html: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text_html | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_background_color {
  normal: string | null;
  dark: string | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text {
  text: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_text;
  background_color: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text_background_color | null;
  background_radius: number | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge {
  /**
   * 랭킹 티어 뱃지 아이콘 URL
   */
  icon_url: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_icon_url | null;
  /**
   * 랭킹 티어 뱃지 텍스트
   */
  text: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge_text | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier {
  /**
   * 랭킹 티어 뱃지
   */
  badge: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier_badge;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_badge_text {
  text: string;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile_badge {
  text: GetProductReviewList_ux_review_list_item_list_reviewer_profile_badge_text;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer_profile {
  /**
   * 랭킹 티어 정보
   */
  ranking_tier: GetProductReviewList_ux_review_list_item_list_reviewer_profile_ranking_tier;
  /**
   * 리뷰 유저 정보 레코드 id
   */
  id: string | null;
  /**
   * 닉네임
   */
  nickname: string | null;
  /**
   * 마스킹 처리된 이메일
   */
  masked_email: string;
  /**
   * 프로필 이미지
   */
  profile_image_url: string;
  /**
   * 랭커 유무
   */
  is_ranker: boolean;
  /**
   * 프로필 공개 여부
   */
  is_visible: boolean;
  /**
   * 뱃지
   */
  badge: GetProductReviewList_ux_review_list_item_list_reviewer_profile_badge | null;
}

export interface GetProductReviewList_ux_review_list_item_list_reviewer {
  /**
   * 리뷰 작성자의 작성당시 신체 정보의 텍스트
   */
  body_text: string | null;
  /**
   * 리뷰 작성자 프로필 정보
   */
  profile: GetProductReviewList_ux_review_list_item_list_reviewer_profile;
}

export interface GetProductReviewList_ux_review_list_item_list_product_info_option_detail_list {
  /**
   * 옵션명
   */
  name: string;
  /**
   * 옵션값
   */
  value: string;
}

export interface GetProductReviewList_ux_review_list_item_list_product_info {
  /**
   * 상품 이미지 주소
   */
  image_url: string;
  /**
   * 상품 이름
   */
  name: string;
  /**
   * 선택된 옵션 상세 정보 목록
   */
  option_detail_list: GetProductReviewList_ux_review_list_item_list_product_info_option_detail_list[] | null;
}

export interface GetProductReviewList_ux_review_list_item_list_seller_event_reward_info_badge_text {
  text: string;
}

export interface GetProductReviewList_ux_review_list_item_list_seller_event_reward_info_badge {
  text: GetProductReviewList_ux_review_list_item_list_seller_event_reward_info_badge_text;
}

export interface GetProductReviewList_ux_review_list_item_list_seller_event_reward_info {
  badge: GetProductReviewList_ux_review_list_item_list_seller_event_reward_info_badge | null;
}

export interface GetProductReviewList_ux_review_list_item_list {
  /**
   * 레코드 ID
   */
  id: string;
  /**
   * 상품 레코드 ID
   */
  product_id: string;
  /**
   * 상품주문 번호
   */
  order_item_number: string;
  /**
   * 상품리뷰 상태(PRE_INSPECTION,  PRE_INSPECTION_INSPECTOR_ASSIGNED,  NORMAL,  NORMAL_ATTACHMENT_DELETED,  DELETED)
   */
  status: string;
  /**
   * 리뷰 내용
   */
  contents: string;
  /**
   * 생성 날짜
   */
  date_created: CrTimestamp;
  /**
   * 수정 날짜
   */
  date_updated: CrTimestamp;
  /**
   * 평점
   */
  rating: number;
  /**
   * 상품 배송유형 뱃지
   */
  fulfillment_badge: GetProductReviewList_ux_review_list_item_list_fulfillment_badge | null;
  /**
   * 국가 정보 code
   */
  country: string;
  /**
   * 사이트 ID
   */
  site_id: string;
  /**
   * 리뷰 타입(TEXT, PHOTO, QUICK)
   */
  type: string;
  /**
   * 칭찬하기 리스트
   */
  like_list: GetProductReviewList_ux_review_list_item_list_like_list[];
  /**
   * 상품 리뷰 답글 목록
   */
  reply_list: GetProductReviewList_ux_review_list_item_list_reply_list[];
  /**
   * 유저 댓글 수
   */
  user_reply_count: number;
  /**
   * 요청한 사용자별 정보
   */
  requested_user: GetProductReviewList_ux_review_list_item_list_requested_user | null;
  /**
   * 상품 리뷰 첨부파일 목록
   */
  attachment_list: GetProductReviewList_ux_review_list_item_list_attachment_list[];
  /**
   * 리뷰 부가 정보
   */
  additional_description: string | null;
  /**
   * 상품리뷰 특성 평가 배열
   */
  attribute_list: GetProductReviewList_ux_review_list_item_list_attribute_list[];
  /**
   * 리뷰 작성자 사용자계정 정보
   */
  reviewer: GetProductReviewList_ux_review_list_item_list_reviewer;
  /**
   * 상품리뷰 상품 정보
   */
  product_info: GetProductReviewList_ux_review_list_item_list_product_info;
  /**
   * 리뷰 이벤트 선정 보상 정보
   */
  seller_event_reward_info: GetProductReviewList_ux_review_list_item_list_seller_event_reward_info | null;
}

export interface GetProductReviewList_ux_review_list {
  total_count: number;
  item_list: GetProductReviewList_ux_review_list_item_list[];
}

export interface GetProductReviewList {
  /**
   * 리뷰 리스트 조회
   */
  ux_review_list: GetProductReviewList_ux_review_list;
}

export interface GetProductReviewListVariables {
  product_id?: string | null;
  limit_count?: number | null;
  skip_count?: number | null;
  has_attachment?: boolean | null;
  order?: UxReviewListOrderType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CommonImageUrl
// ====================================================

export interface CommonImageUrl {
  normal: string;
  dark: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CommonColor
// ====================================================

export interface CommonColor {
  normal: string | null;
  dark: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CommonText
// ====================================================

export interface CommonText_color {
  normal: string | null;
  dark: string | null;
}

export interface CommonText_html {
  normal: string | null;
  dark: string | null;
}

export interface CommonText {
  text: string;
  color: CommonText_color | null;
  html: CommonText_html | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BackgroundCommonText
// ====================================================

export interface BackgroundCommonText_text_color {
  normal: string | null;
  dark: string | null;
}

export interface BackgroundCommonText_text_html {
  normal: string | null;
  dark: string | null;
}

export interface BackgroundCommonText_text {
  text: string;
  color: BackgroundCommonText_text_color | null;
  html: BackgroundCommonText_text_html | null;
}

export interface BackgroundCommonText_background_color {
  normal: string | null;
  dark: string | null;
}

export interface BackgroundCommonText {
  text: BackgroundCommonText_text;
  background_color: BackgroundCommonText_background_color | null;
  background_radius: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReviewAttachment
// ====================================================

export interface ReviewAttachment {
  /**
   * 원본 파일 URL
   */
  original_url: string;
  /**
   * 썸네일 파일 URL
   */
  thumbnail_url: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReviewAttribute
// ====================================================

export interface ReviewAttribute_question {
  label: string;
  value: string;
  category: string;
}

export interface ReviewAttribute_answer {
  label: string;
  value: string;
}

export interface ReviewAttribute {
  /**
   * 질문
   */
  question: ReviewAttribute_question;
  /**
   * 답변
   */
  answer: ReviewAttribute_answer;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReviewLike
// ====================================================

export interface ReviewLike {
  type: string;
  count: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductOptionDetail
// ====================================================

export interface ProductOptionDetail {
  /**
   * 옵션명
   */
  name: string;
  /**
   * 옵션값
   */
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReviewProductPrice
// ====================================================

export interface ReviewProductPrice {
  /**
   * 최종 노출 가격
   */
  final_price: number;
  /**
   * 최종 노출 가격 기준 할인율
   */
  final_price_discount_rate: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RankingTierBadge
// ====================================================

export interface RankingTierBadge_icon_url {
  normal: string;
  dark: string | null;
}

export interface RankingTierBadge_text_text_color {
  normal: string | null;
  dark: string | null;
}

export interface RankingTierBadge_text_text_html {
  normal: string | null;
  dark: string | null;
}

export interface RankingTierBadge_text_text {
  text: string;
  color: RankingTierBadge_text_text_color | null;
  html: RankingTierBadge_text_text_html | null;
}

export interface RankingTierBadge_text_background_color {
  normal: string | null;
  dark: string | null;
}

export interface RankingTierBadge_text {
  text: RankingTierBadge_text_text;
  background_color: RankingTierBadge_text_background_color | null;
  background_radius: number | null;
}

export interface RankingTierBadge {
  /**
   * 랭킹 티어 뱃지 아이콘 URL
   */
  icon_url: RankingTierBadge_icon_url | null;
  /**
   * 랭킹 티어 뱃지 텍스트
   */
  text: RankingTierBadge_text | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReviewListItem
// ====================================================

export interface ReviewListItem_fulfillment_badge_image_size {
  /**
   * 이미지 너비 크기
   */
  width: number;
  /**
   * 이미지 높이 크기
   */
  height: number;
}

export interface ReviewListItem_fulfillment_badge {
  type: string | null;
  text: string | null;
  image_url: string;
  image_size: ReviewListItem_fulfillment_badge_image_size | null;
}

export interface ReviewListItem_like_list {
  type: string;
  count: number;
}

export interface ReviewListItem_reply_list {
  /**
   * 상품리뷰 답글 내용
   */
  contents: string;
}

export interface ReviewListItem_requested_user {
  is_mine: boolean;
  liked_list: string[];
  is_abuse_reported: boolean;
}

export interface ReviewListItem_attachment_list {
  /**
   * 원본 파일 URL
   */
  original_url: string;
  /**
   * 썸네일 파일 URL
   */
  thumbnail_url: string;
  /**
   * 상품리뷰 첨부파일 상태 (NORMAL, EXCLUDED_BY_USER, DELETED_BY_ADMIN)
   */
  status: string;
}

export interface ReviewListItem_attribute_list_question {
  label: string;
  value: string;
  category: string;
}

export interface ReviewListItem_attribute_list_answer {
  label: string;
  value: string;
}

export interface ReviewListItem_attribute_list {
  /**
   * 질문
   */
  question: ReviewListItem_attribute_list_question;
  /**
   * 답변
   */
  answer: ReviewListItem_attribute_list_answer;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_icon_url {
  normal: string;
  dark: string | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_text_text_color {
  normal: string | null;
  dark: string | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_text_text_html {
  normal: string | null;
  dark: string | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_text_text {
  text: string;
  color: ReviewListItem_reviewer_profile_ranking_tier_badge_text_text_color | null;
  html: ReviewListItem_reviewer_profile_ranking_tier_badge_text_text_html | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_text_background_color {
  normal: string | null;
  dark: string | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge_text {
  text: ReviewListItem_reviewer_profile_ranking_tier_badge_text_text;
  background_color: ReviewListItem_reviewer_profile_ranking_tier_badge_text_background_color | null;
  background_radius: number | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier_badge {
  /**
   * 랭킹 티어 뱃지 아이콘 URL
   */
  icon_url: ReviewListItem_reviewer_profile_ranking_tier_badge_icon_url | null;
  /**
   * 랭킹 티어 뱃지 텍스트
   */
  text: ReviewListItem_reviewer_profile_ranking_tier_badge_text | null;
}

export interface ReviewListItem_reviewer_profile_ranking_tier {
  /**
   * 랭킹 티어 뱃지
   */
  badge: ReviewListItem_reviewer_profile_ranking_tier_badge;
}

export interface ReviewListItem_reviewer_profile_badge_text {
  text: string;
}

export interface ReviewListItem_reviewer_profile_badge {
  text: ReviewListItem_reviewer_profile_badge_text;
}

export interface ReviewListItem_reviewer_profile {
  /**
   * 랭킹 티어 정보
   */
  ranking_tier: ReviewListItem_reviewer_profile_ranking_tier;
  /**
   * 리뷰 유저 정보 레코드 id
   */
  id: string | null;
  /**
   * 닉네임
   */
  nickname: string | null;
  /**
   * 마스킹 처리된 이메일
   */
  masked_email: string;
  /**
   * 프로필 이미지
   */
  profile_image_url: string;
  /**
   * 랭커 유무
   */
  is_ranker: boolean;
  /**
   * 프로필 공개 여부
   */
  is_visible: boolean;
  /**
   * 뱃지
   */
  badge: ReviewListItem_reviewer_profile_badge | null;
}

export interface ReviewListItem_reviewer {
  /**
   * 리뷰 작성자의 작성당시 신체 정보의 텍스트
   */
  body_text: string | null;
  /**
   * 리뷰 작성자 프로필 정보
   */
  profile: ReviewListItem_reviewer_profile;
}

export interface ReviewListItem_product_info_option_detail_list {
  /**
   * 옵션명
   */
  name: string;
  /**
   * 옵션값
   */
  value: string;
}

export interface ReviewListItem_product_info {
  /**
   * 상품 이미지 주소
   */
  image_url: string;
  /**
   * 상품 이름
   */
  name: string;
  /**
   * 선택된 옵션 상세 정보 목록
   */
  option_detail_list: ReviewListItem_product_info_option_detail_list[] | null;
}

export interface ReviewListItem_seller_event_reward_info_badge_text {
  text: string;
}

export interface ReviewListItem_seller_event_reward_info_badge {
  text: ReviewListItem_seller_event_reward_info_badge_text;
}

export interface ReviewListItem_seller_event_reward_info {
  badge: ReviewListItem_seller_event_reward_info_badge | null;
}

export interface ReviewListItem {
  /**
   * 레코드 ID
   */
  id: string;
  /**
   * 상품 레코드 ID
   */
  product_id: string;
  /**
   * 상품주문 번호
   */
  order_item_number: string;
  /**
   * 상품리뷰 상태(PRE_INSPECTION,  PRE_INSPECTION_INSPECTOR_ASSIGNED,  NORMAL,  NORMAL_ATTACHMENT_DELETED,  DELETED)
   */
  status: string;
  /**
   * 리뷰 내용
   */
  contents: string;
  /**
   * 생성 날짜
   */
  date_created: CrTimestamp;
  /**
   * 수정 날짜
   */
  date_updated: CrTimestamp;
  /**
   * 평점
   */
  rating: number;
  /**
   * 상품 배송유형 뱃지
   */
  fulfillment_badge: ReviewListItem_fulfillment_badge | null;
  /**
   * 국가 정보 code
   */
  country: string;
  /**
   * 사이트 ID
   */
  site_id: string;
  /**
   * 리뷰 타입(TEXT, PHOTO, QUICK)
   */
  type: string;
  /**
   * 칭찬하기 리스트
   */
  like_list: ReviewListItem_like_list[];
  /**
   * 상품 리뷰 답글 목록
   */
  reply_list: ReviewListItem_reply_list[];
  /**
   * 유저 댓글 수
   */
  user_reply_count: number;
  /**
   * 요청한 사용자별 정보
   */
  requested_user: ReviewListItem_requested_user | null;
  /**
   * 상품 리뷰 첨부파일 목록
   */
  attachment_list: ReviewListItem_attachment_list[];
  /**
   * 리뷰 부가 정보
   */
  additional_description: string | null;
  /**
   * 상품리뷰 특성 평가 배열
   */
  attribute_list: ReviewListItem_attribute_list[];
  /**
   * 리뷰 작성자 사용자계정 정보
   */
  reviewer: ReviewListItem_reviewer;
  /**
   * 상품리뷰 상품 정보
   */
  product_info: ReviewListItem_product_info;
  /**
   * 리뷰 이벤트 선정 보상 정보
   */
  seller_event_reward_info: ReviewListItem_seller_event_reward_info | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * 상품리뷰 목록 정렬
 */
export enum UxReviewListOrderType {
  BEST_SCORE_DESC = "BEST_SCORE_DESC",
  DATE_CREATED_DESC = "DATE_CREATED_DESC",
  EXPERIENCE_GROUP_BEST_SCORE_DESC = "EXPERIENCE_GROUP_BEST_SCORE_DESC",
  LIKE_COUNT_DESC = "LIKE_COUNT_DESC",
  RATING_ASC = "RATING_ASC",
  RATING_DESC = "RATING_DESC",
  SCORE_DESC = "SCORE_DESC",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
